import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@material-ui/core';
import {
  // AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  User as UserIcon,
  Send as SendIcon,
  LogOut as LogOutIcon,
} from 'react-feather';
import NavItem from './NavItem';
import localStorageUtils from 'src/utils/localStorageUtils';
import { IMGAE_REQUEST_PREFIX } from 'src/utils/appConstants';

const items = [
  {
    href: '/app/events',
    icon: SendIcon,
    title: 'My Events'
  },
  // {
  //   href: '/app/dashboard',
  //   icon: BarChartIcon,
  //   title: 'My Dashboard'
  // },
  // {
  //   href: '/app/running-detail',
  //   icon: SendIcon,
  //   title: 'Running Submit'
  // },  
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Runner Profile'
  },
  {
    href: '/logout',
    icon: LogOutIcon,
    title: 'Logout'
  }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const runer = localStorageUtils.getCurrentUser();

  useEffect(() => {
    // console.log('useEffect: ', openMobile);
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        <Avatar
          src={IMGAE_REQUEST_PREFIX + runer.avatar}
          sx={{
            height: 90,
            width: 90,
            boxShadow: 12
          }}
        />
        <Typography
          color="textPrimary"
          variant="h5"
        >
          {runer.firstName}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {runer.alumni}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default DashboardSidebar;
